<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Tax Status Detail</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Tax Code"
            :class="classPadding"
            v-model="taxStatus.taxCode"
            readonly
          >
            <template slot="append">
              <v-icon @click.stop="searchTaxStatus">mdi-magnify</v-icon>
              <!-- <span class="required">*</span> -->
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Tax Type"
            :class="classPadding"
            v-model="taxStatus.taxType"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Range 1"
            :class="classPadding"
            v-model="taxStatus.tRange1"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Range 2"
            :class="classPadding"
            v-model="taxStatus.tRange2"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Percent"
            :class="classPadding"
            v-model="taxStatus.tPercent"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Plus"
            :class="classPadding"
            v-model="taxStatus.tPlus"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Tax Code"
                  :class="classPadding"
                  v-model="editTaxStatus.taxCode"
                  readonly
                >
                  <template slot="append">
                    <v-icon @click.stop="searchTaxStatus">mdi-magnify</v-icon>
                    <!-- <span class="required">*</span> -->
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Tax Type"
                  :class="classPadding"
                  v-model="editTaxStatus.taxType"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Range 1"
                  :class="classPadding"
                  v-model="editTaxStatus.tRange1"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Range 2"
                  :class="classPadding"
                  v-model="editTaxStatus.tRange2"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Percent"
                  :class="classPadding"
                  v-model="editTaxStatus.tPercent"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Plus"
                  :class="classPadding"
                  v-model="editTaxStatus.tPlus"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="taxStatusDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Tax Status</span>
        </v-card-title>
        <v-card-text>
          <tax-status-list>
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectTaxStatus(item)" text outlined
                >Select</v-btn
              >
            </template>
          </tax-status-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="taxStatusDialog = false" text color="error"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import taxType from "../../../../enums/taxType";
import TaxStatusList from "../tax-status/List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/taxStatusDetails";
export default {
  metaInfo: {
    title: "Tax Status Details",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List,
    TaxStatusList
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    taxStatus: {},
    isSaving: false,
    editTaxStatus: {},
    editDialog: false,
    isUpdating: false,
    taxType,
    taxStatusDialog: false
  }),
  methods: {
    save() {
      this.$axios
        .post(`${API_ENDPOINT}`, this.taxStatus)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editTaxStatus)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    reset() {
      this.taxStatus = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editTaxStatus = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.taxCodeDId}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    searchTaxStatus() {
      this.taxStatusDialog = true;
    },
    selectTaxStatus(item) {
      this.taxStatus.taxCode = item.taxCode;
      this.taxStatus.taxType = item.taxType;
      this.taxStatusDialog = false;
    }
  },
  created() {
    this.getUserAccessRights("TaxStatusD");
  }
};
</script>